import React, {useState, useEffect} from 'react'
import DegreeDaysChart from 'components/dd-chart/DegreeDaysChart'
import { useParams } from "react-router";
import { Link,useNavigate } from "react-router-dom";
import Header from 'components/header/Header';
import { LeftCircleOutlined} from "@ant-design/icons";
import { useGetUserByIdQuery } from 'api/userApi';
import { Grid, Typography, Box } from "@mui/material";
import { seperateStringJoinedWithDash} from 'helper/Utils';
import { BellOutlined } from '@ant-design/icons';
import userRole from 'constants/userRole';
import { Spin } from 'antd';
import {
  useGetNotificationSubcriptionStatusQuery,
  useCreatePestNotificationSubscriptionMutation,
  useDeletePestNotificationSubscriptionMutation, } from 'api/degreeDaysApi';
  import { Button } from 'antd';
import { Notification } from 'components/notification/Notification';
const ChartDisplay = () => {
   const user = JSON.parse(localStorage.getItem("user"));
    const { pestId, pestName, cropId,cropName, stationId } = useParams();
    const [userId, setUserId] = useState(null);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const userDetailsQuery = useGetUserByIdQuery(user?.uId, {
      skip: !user
    });
    const {
      data: notificationSubData,
      isLoading: notificationSubLoading,
      error: notificationSubError,
    } = useGetNotificationSubcriptionStatusQuery(
      { pestId: pestId, stationId: stationId, userId:userId},{
        skip:!userId || !pestId || !stationId ||  !userId
      });
    const [userDetails, setUserDetails] = useState(null);
    const [role, setRole] = useState([]);
    const navigate = useNavigate();
    const [isEditable, setIsEditable] = useState(false);
    const [createPestNotificationSubscription, { loading: createLoading }] = useCreatePestNotificationSubscriptionMutation();
    const [deletePestNotificationSubscription] = useDeletePestNotificationSubscriptionMutation();
    const isMobile = window.innerWidth <= 768;  

    const handleBackClick = () => {
        navigate(-1);
      };
      const breadcrumbItems = isMobile
      ? [
          {
            title: (
              <Typography
                onClick={handleBackClick}
                style={{ textTransform: 'capitalize', color: '#1DA1F2', textDecoration: 'none', cursor: 'pointer' }}
              >
                <LeftCircleOutlined /> Back
              </Typography>
            ),
          },
        ]
      :[
        {
          title: (
            <Link to={'/ddps'}>
              <Typography style={{ textTransform: 'capitalize', color: '#1DA1F2',  textDecoration: 'none'}}>Home</Typography>
            </Link>
          ),
        },
        {
          title: (
            <Link  to={`/ddps/insects/select-entities-and-weather-station`}>
              <Typography style={{ textTransform: 'capitalize', color: '#1DA1F2',  textDecoration: 'none'}}>Entities and Weather Stations</Typography>
            </Link>
          ),
        },
        {
          title: (
            <Typography style={{ textTransform: 'capitalize',  textDecoration: 'none'}}>{seperateStringJoinedWithDash(cropName)}</Typography>
          ),
        },
        {
          title: (
            <Typography style={{ textTransform: 'capitalize',  textDecoration: 'none'}}>{seperateStringJoinedWithDash(pestName)}</Typography>
          ),
        },
        {
          title: (
            <Typography style={{ textTransform: 'capitalize',  textDecoration: 'none'}}>Degree Day Dashboard</Typography>
          ),
        },
      ]
      useEffect(() => {
        if (userDetailsQuery?.data){
          setRole(userDetailsQuery?.data ? userDetailsQuery?.data?.uRole : null);
          setUserDetails(userDetailsQuery?.data)
          setIsEditable(
            userDetailsQuery?.data?.data?.uRole === userRole.ADMIN || userDetailsQuery?.data?.data?.uRole === userRole.MODERATOR ? true : false
          );
          setUserId(userDetailsQuery?.data?.data?.uId);
        }
      }, [userDetailsQuery.status]);


      useEffect(() => {

          setIsSubscribed(notificationSubData)
    
      }, [notificationSubData]);


      const handleSubscription = async  () => {
        if (isSubscribed) {
          try {
            const response = await deletePestNotificationSubscription({
              pestId,
              stationId,
              userId,
            }).unwrap();
        
            Notification(
              "success",
              "Operation successful",
              "Subscription to Pest and Weather Station Alerts deleted successfully"
            );
          } catch (error) {
            if (error.status === 404 && error.data?.message === "User was not subscribed.") {
              Notification(
                "info",
                "No Action Needed",
                "The user was not subscribed, so no subscription was deleted."
              );
            } else {
              Notification(
                "error",
                "Operation failed",
                "Could not delete subscription due to an unexpected error."
              );
            }
          }
     
        } else {
          try {
            const response = await createPestNotificationSubscription({
              PestId: pestId,
              StationId: stationId,
              UserId: userId,
            }).unwrap();
        
            Notification(
              "success",
              "Operation successful",
              "Subscription to Pest and Weather Station Alerts created successfully"
            );
          } catch (error) {
            if (error.status === 409 && error.data?.message === "User is already subscribed.") {
              Notification(
                "info",
                "Already Subscribed",
                "The user is already subscribed to this Pest and Weather Station."
              );
            } else if (error.status === 404 && error.data?.message === "User does not exist.") {
              Notification(
                "error",
                "User Not Found",
                "The specified user does not exist, so the subscription could not be created."
              );
            } else {
              Notification(
                "error",
                "Operation failed",
                "Could not create subscription due to an unexpected error."
              );
            }
          }}
      };


      if(notificationSubLoading ){
        return <Spin spinning={notificationSubLoading} fullscreen />
       }
     
  return (
<Grid container spacing={2}>
  <Grid item xs={12} lg={12}>
    <Header
      breadcrumbItems={breadcrumbItems}
    />

    <Grid container>
      <Grid item xs={12}>
      {
  userId && (
    <div style={{ textAlign: 'right' }}>
      <Button onClick={handleSubscription} type="primary" icon={<BellOutlined />}>
        {isSubscribed
          ? 'Unsubscribe from Pest and Weather Station Alerts'
          : 'Subscribe to Pest and Weather Station Alerts'}
      </Button>
    </div>
  )
}

       
      </Grid>
    </Grid>
  </Grid>

  <Grid item xs={12} lg={12}>
    {/* Additional Grid Content */}
  </Grid>

  <Grid item xs={12} lg={12}>
    <DegreeDaysChart pestId={pestId} pestName={pestName} />
  </Grid>
</Grid>

  )
}

export default ChartDisplay